import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withClickOutside } from '../../hoc/clickOutside';
import styles from './openerContent.module.scss';

class OpenerContentComponent extends Component {
  handleClickOutside = ({target}) => {
    const {
      btn,
      handleClickOutside,
    } = this.props;
    if (!handleClickOutside || !btn || btn.contains(target) || btn === target) {
      return;
    }

    handleClickOutside();
  }

  render() {
    const {
      className = '',
      isOpen,
      children,
      close,
    } = this.props;

    return (
      <div className={`${styles.content} opener ${isOpen ? '_opened' : ''}  ${className}`}>
        {children && React.cloneElement(
          children,
          { close: close },
        )}
      </div>
    );
  }
}

export const OpenerContent = withClickOutside(OpenerContentComponent);

OpenerContentComponent.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  btn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  handleClickOutside: PropTypes.func,
  close: PropTypes.func,
};
